module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tracker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('b-card', {
    attrs: {
      "no-block": "",
      "variant": "outline-primary",
      "header": "Current Initiative Pass",
      "inverse": false
    }
  }, [_c('b-table', {
    staticClass: "card-table",
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.ipTableItems,
      "fields": _vm.ipTableFields
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('span', {
          class: {
            'text-completed': data.item.completed
          }
        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])]
      }
    }, {
      key: "initiative",
      fn: function(data) {
        return [_c('span', {
          class: {
            'text-completed': data.item.completed
          }
        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mt-4",
    attrs: {
      "no-block": "",
      "variant": "outline-secondary",
      "header": "Upcoming"
    }
  }, [_c('b-table', {
    staticClass: "card-table",
    attrs: {
      "striped": "",
      "items": _vm.upcomingItems,
      "fields": _vm.upcomingFields
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_vm._v(_vm._s(data.value))]
      }
    }, {
      key: "initiative",
      fn: function(data) {
        return [_vm._v(_vm._s(data.value))]
      }
    }, {
      key: "combatTurn",
      fn: function(data) {
        return [_vm._v(_vm._s(data.value))]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', [_vm._v("It's Six's turn.")]), _vm._v(" "), _c('p', [_vm._v("\n        Current combat turn: " + _vm._s(_vm.combatTurn) + " "), _c('br'), _vm._v("\n        Current initiative: " + _vm._s(_vm.initiative) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fd9beba8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracker.vue
// module id = 116
// module chunks = 2